import React from "react";
import { useTranslation } from "react-i18next";
import PharmacyCard from "../PharmacyCard/PharmacyCard";
import LinkClinic from "../../components/LinkClinic/LinkClinic";
import "./ClinicList.css";

export default function ClinicList({
	  clinics = [],
	  onClinicClick,
	  selectedClinic,
	  getClinicData,
	}) {
	  const { t } = useTranslation();

	  if (!clinics || clinics.length === 0) {
	    return <p>🔍 {t("locators.clinic.empty")}</p>;
	  }

  return (
    <div className="clinic-list">
      {clinics.map((clinic, index) => (
        <React.Fragment key={clinic.place_id || clinic.id}>
          {/* Carte de la clinique */}
          <PharmacyCard
            pharmacy={clinic}
            selectedPharmacy={selectedClinic}
            onClick={onClinicClick}
          />
          
          {/* Afficher LinkClinic juste après la clinique sélectionnée */}
          {selectedClinic?.id === clinic.id && (
            <div className="clinic-details-inline" id="link-clinic-details">
              <LinkClinic clinicData={getClinicData(clinic)} />
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

